/**
 * Хосты публичного маркетинга и портала доков (один SPA-бандл с markbase.ru).
 * Другие поддомены не попадают сюда — для них не включаем оболочку лендинга и т.п.
 */
import { isLoopbackHost } from './loopbackHost';

export const MARKBASE_PUBLIC_MARKETING_HOSTNAMES = ['markbase.ru', 'www.markbase.ru', 'docs.markbase.ru'];

/**
 * Канонический хост приложения: любой не-app хост в зоне markbase.ru → app.markbase.ru
 * (в т.ч. docs.markbase.ru — без app.docs.markbase.ru).
 * Вне зоны markbase.ru — прежняя эвристика app.{hostname} / app.{hostname без www.}.
 */
export function resolveMarkbaseProductionAppHostname(hostname) {
  const h = String(hostname || '').toLowerCase();
  if (!h) return 'app.markbase.ru';
  if (isLoopbackHost(h)) return h;
  if (h.startsWith('app.')) return h;
  if (h === 'markbase.ru' || h.endsWith('.markbase.ru')) {
    return 'app.markbase.ru';
  }
  return h.startsWith('www.') ? `app.${h.slice(4)}` : `app.${h}`;
}

/** Пути только публичного маркетинга на markbase.ru / docs (не кабинет). */
export function isPublicMarketingContentPath(pathname) {
  const p = String(pathname || '').split('?')[0] || '/';
  const publicPaths = new Set([
    '/',
    '/about',
    '/pricing',
    '/contact',
    '/company',
    '/privacy',
    '/terms',
    '/personal-data',
    '/cookies',
    '/docs',
    '/help',
    '/legal',
    '/trust',
  ]);
  if (publicPaths.has(p)) return true;
  if (p.startsWith('/docs/') || p.startsWith('/help/') || p.startsWith('/product/')) return true;
  return false;
}

/** Канонический URL кабинета с маркетингового хоста (markbase.ru → app.markbase.ru). */
export function resolveMarketingAppRedirectHref(locationLike) {
  if (typeof window === 'undefined' || !locationLike) return null;
  const protocol = locationLike.protocol || window.location.protocol;
  const hostname = locationLike.hostname || window.location.hostname;
  const pathname = locationLike.pathname || '/';
  const search = locationLike.search || '';
  const hash = locationLike.hash || '';
  const appHost = resolveMarkbaseProductionAppHostname(hostname);
  return `${protocol}//${appHost}${pathname}${search}${hash}`;
}

/** Шапка/подвал маркетинга и особый 404 — только эти хосты (+ loopback с публичными путями). */
export function isPublicMarketingShellActive(hostname, pathname) {
  const h = String(hostname || '').toLowerCase();
  const p = String(pathname || '');
  if (MARKBASE_PUBLIC_MARKETING_HOSTNAMES.includes(h)) return true;
  if (isLoopbackHost(h)) {
    const publicPaths = ['/', '/about', '/pricing', '/contact', '/company', '/privacy', '/terms', '/personal-data', '/cookies', '/docs', '/help'];
    return publicPaths.includes(p) || p.startsWith('/docs/') || p.startsWith('/help/') || p.startsWith('/product/');
  }
  return false;
}
